<template>
  <transition mode="out-in" enter-active-class="animated fadeInDown" leave-active-class="animated zoomOutDown">
    <div v-if="showPanel" class="mask">
      <div class="other-box" @click="showPanel = false"></div>
      <div class="school-box">
        <div class="list">
          <div v-for="(item, index) of info.schools" :key="index" :class="item.id === schoolId ? 'item checked border-bottom' : 'item border-bottom'" @click="schoolId = item.id">
            <i v-if="item.id === schoolId" class="iconfont">&#xe614;</i>
            <i v-else class="iconfont">&#xe613;</i>
            <label>{{item.name}}</label>
            <span class="text-ellipsis hide-xs-only">（{{item.street}}）</span>
          </div>
        </div>
        <div class="action-box border-top">
          <div class="action close"><label @click="showPanel = false">关闭</label></div>
          <div class="action change"><label @click="handleSchoolChange">切换</label></div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import { mapState } from 'vuex'
import { modify } from '@/api/user'

export default {
  name: 'ChangeSchool',
  computed: {
    ...mapState(['info'])
  },
  data() {
    return {
      showPanel: false,
      schoolId: undefined
    }
  },
  watch: {
    info: {
      handler(val) {
        if (val) {
          this.schoolId = val.schoolId
        }
      },
      immediate: true
    }
  },
  mounted() {
  },
  methods: {
    handleSchoolChange() {
      modify({schoolId: this.schoolId}).then(resp => {
        if (resp.code === 0) {
          this.$store.dispatch('GetUserInfo').then(resp => {
            this.showPanel = false
          }).catch(() => {})
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
  @import "../styles/variables";
  .other-box {
    position: fixed;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
  }
  .school-box {
    background: @white1-color;
    padding: 50px 50px 100px;
    border-radius: 10px;
    height: 50%;
    position: relative;
    .list {
      height: 100%;
      overflow-y: auto;
      .item {
        font-size: 30px;
        padding: 10px 0;
        margin: 10px auto;
        cursor: pointer;
        display: flex;
        align-items: center;
        &:last-child {
          background: none;
        }
        &.checked {
          i, label {
            color: dodgerblue;
          }
        }
        i {
          font-size: 30px;
          margin-right: 10px;
          color: @black3-color;
        }
        label {
          cursor: pointer;
          font-weight: 300;
          color: @black2-color;
        }
        span {
          cursor: pointer;
          font-weight: 200;
          color: @black3-color;
        }
      }
    }
    .action-box {
      position: absolute;
      left: 0;
      right: 0;
      bottom: 0;
      height: 80px;
      display: flex;
      align-items: center;
      .action {
        flex: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 30px;
        height: 80px;
        label {
          font-weight: 200;
          cursor: pointer;
        }
        &.close {
          color: @black4-color;
          border-bottom-left-radius: 10px;
        }
        &.change {
          color: dodgerblue;
          border-bottom-right-radius: 10px;
        }
        &:hover {
          label {
            font-weight: 500;
            color: red;
          }
        }
      }
    }
  }

  @media (max-width: @screen-xs-max) {
    .other-box {
    }
    .school-box {
      padding: 150px 150px 300px;
      border-radius: 30px;
      height: 30%;
      .list {
        .item {
          font-size: 90px;
          padding: 30px 0;
          margin: 30px auto;
          i {
            font-size: 90px;
            margin-right: 30px;
          }
        }
      }
      .action-box {
        height: 240px;
        .action {
          font-size: 90px;
          height: 240px;
        }
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/ChangeSchool.vue